import React from "react";
import { ChevronLeft } from "lucide-react";

const CreateSurveyHero = ({
  currentStep,
  handleBackToDetails,
  handleBackToQuestions,
}) => {
  const showBackButton = currentStep === 2 || currentStep === 3;

  return (
    <div className="row g-3">
      <div className="col-12">
        <div className="cs-card cs-header-card">
          <div className="row g-3 align-items-start">
            {showBackButton && (
              <div className="col-auto">
                <button
                  type="button"
                  className="cs-back-btn"
                  onClick={
                    currentStep === 2
                      ? handleBackToDetails
                      : handleBackToQuestions
                  }
                >
                  <ChevronLeft size={24} />
                </button>
              </div>
            )}

            <div className="col">
              <h1>Create Survey</h1>
              <p>Build, Target, Price, And Publish A Survey From One Place.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateSurveyHero;
